import * as React from 'react';

import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './ui/carousel';
import { cn } from '@lib/utils';
import { PhotoPackVariant } from './PhotoPack/PhotoPackV3/utils';
import Autoplay from 'embla-carousel-autoplay';

interface CardCarouselProps {
  children: React.ReactNode;
  className?: string;
  variant: PhotoPackVariant;
  autoplay?: boolean;
  hideArrows?: boolean;
}

export function CardCarousel({
  children,
  className = '',
  variant = 'samples',
  autoplay = false,
  hideArrows = false
}: CardCarouselProps) {
  return (
    <Carousel
      opts={{
        align: 'start',
        loop: true
      }}
      className={`w-full ${className}`}
      plugins={autoplay ? [Autoplay({ delay: 10000 })] : []}
    >
      <CarouselContent className="ml-1 md:-ml-4 py-1">
        {React.Children.map(children, (child, index) => (
          <CarouselItem
            key={index}
            className={cn(
              // 'pl-2 md:pl-5 lg:basis-1/4 xl:basis-1/5',
              variant === 'samples' && 'basis-[280px] pl-2 md:pl-5 lg:basis-1/4 xl:basis-1/5',
              variant === 'hero' && 'basis-full'
            )}
          >
            <div className="p-1">{child}</div>
          </CarouselItem>
        ))}
      </CarouselContent>
      {!hideArrows && (
        <>
          <CarouselPrevious className="hidden md:flex -left-3 bg-muted/80" />
          <CarouselNext className="hidden md:flex -right-3 bg-muted/80" />
        </>
      )}
    </Carousel>
  );
}
